"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFakeDiscriminationsPrerequisite = exports.generateDifficultiesCNED = exports.extractRandomInversibleSubmatrix = exports.generateDifficultiesAct = exports.generateDiscriminationsPrerequisite = exports.generateDescendantByAct = exports.generateAncestorByAct = exports.generateTrainingQmatrix = exports.generateQmatrixPrerequisite = void 0;
const parametric_graph_1 = require("@evidenceb/parametric-graph");
/**
 * Generates a Q-matrix based on the same config object as the one used in the BM. For the generated Q-matrix,
 * 1 objective <-> 1 Knowledge Component. Each question involves several KCs (the objective to which the
 * activity belongs and all its prerequisites)
 * @param params : config object (same as in the BM)
 * @param graph : paramtric graph created with the lib @evidenceb/parametric-graph
 * @returns the Q-matrix under the hypothesis of hierarchical knowledge space
 */
let generateQmatrixPrerequisite = (params) => {
    const QMatrix = {};
    const ModuleData = params["graph"]["graph"];
    const idModule = params["graph"]["main_act"];
    const objectives = ModuleData[idModule]["subgroups"][0];
    const ontology = params["graph"]["exercises_ontology"];
    const graph = (0, parametric_graph_1.makeGraphFromData)(params, idModule);
    for (let j = 0; j < objectives.length; j++) {
        let obj = objectives[j];
        for (let act of ModuleData[obj]["subgroups"][0]) {
            for (let i = 0; i < ontology.length; i++) {
                if (act == ontology[i]["id"]) {
                    let QmatRow = new Array(objectives.length).fill(0);
                    for (let anc of (0, parametric_graph_1.getAncestors)(graph, act)) {
                        let ind = objectives.indexOf(anc);
                        if (ind >= 0) {
                            QmatRow[ind] = 1;
                        }
                    }
                    for (let ex of params["graph"]["exercises_ontology"][i]["exerciseIds"]) {
                        QMatrix[ex] = QmatRow;
                    }
                    break;
                }
            }
        }
    }
    return QMatrix;
};
exports.generateQmatrixPrerequisite = generateQmatrixPrerequisite;
let generateTrainingQmatrix = (params) => {
    const QMatrix = {};
    const ModuleData = params["graph"]["graph"];
    const idModule = params["graph"]["main_act"];
    const objectives = ModuleData[idModule]["subgroups"][0];
    const graph = (0, parametric_graph_1.makeGraphFromData)(params, idModule);
    for (let j = 0; j < ModuleData[idModule]["subgroups"][0].length; j++) {
        let obj = ModuleData[idModule]["subgroups"][0][j];
        for (let act of ModuleData[obj]["subgroups"][0]) {
            QMatrix[act] = new Array(ModuleData[idModule]["subgroups"][0].length).fill(0);
            for (let anc of (0, parametric_graph_1.getAncestors)(graph, act)) {
                let ind = objectives.indexOf(anc);
                if (ind >= 0) {
                    QMatrix[act][ind] = 1;
                }
            }
        }
    }
    return QMatrix;
};
exports.generateTrainingQmatrix = generateTrainingQmatrix;
/**
 * Generates discriminations for items if we don't have enough data for training. Here, we assume that
 * one question involves the objective to which it belongs and all of its prerequisites. The discrimination
 * along the main KC is higher than the discrimination along other dimensions.
 * @param params : config object (same as in the BM)
 * @param graph : representation of the parametric graph created with @evidenceb/parametric-graph lib
 * @param obj_list : list of all the objectives in the module
 * @param act_dict : dict of all activities with their corresponding objectives => {objId : [actIds]}
 * @returns the discriminations for each item of the test bank under the hypothesis of hierarchical knowledge
 * space
 */
function generateAncestorByAct(params, activities, graph) {
    let ancestors = {};
    let acts = Object.values(activities).flat();
    for (let act of acts) {
        ancestors[act] = [];
        let ancs = (0, parametric_graph_1.getAncestors)(graph, act);
        for (let anc of ancs) {
            if (acts[act] != anc && acts.includes(anc)) {
                ancestors[act].push(anc);
            }
        }
    }
    return ancestors;
}
exports.generateAncestorByAct = generateAncestorByAct;
function generateDescendantByAct(params, activities, graph) {
    let descendants = {};
    let acts = Object.values(activities).flat();
    for (let act of acts) {
        descendants[act] = [];
        let ancs = (0, parametric_graph_1.getDescendants)(graph, act);
        for (let anc of ancs) {
            if (act != anc && acts.includes(anc)) {
                descendants[act].push(anc);
            }
        }
    }
    return descendants;
}
exports.generateDescendantByAct = generateDescendantByAct;
let generateDiscriminationsPrerequisite = (params, graph, obj_list, act_dict) => {
    const discriminations = {};
    const discriminations_no_anc = {};
    const objectives = obj_list;
    // Parcours les objectifs
    for (let i = 0; i < objectives.length; i++) {
        let obj = objectives[i]; //sélectionne un objectif
        let ancestors = (0, parametric_graph_1.getAncestors)(graph, obj); // récupère les ancestors de cette objectif => objectif et activité 
        let discRow = new Array(objectives.length).fill(0);
        discRow[i] = 1;
        let discRow_anc = new Array(objectives.length).fill(0);
        discRow_anc[i] = 1;
        for (let j = 0; j < ancestors.length; j++) {
            if (objectives.includes(ancestors[j])) { // Si l'élément j est un objectif alors l'élément juste après est la plus haute activité d'un objectif qui a le rôle de ancestor
                let anc_obj = Object.keys(act_dict).find(key => act_dict[key].includes(ancestors[j + 1]));
                if (objectives.indexOf(anc_obj) != -1) {
                    discRow[objectives.indexOf(anc_obj)] = (act_dict[anc_obj].indexOf(ancestors[j + 1]) + 1) / act_dict[anc_obj].length; // valeur se base sur l'activité prérequis sur le nb d'activité totale
                    for (let k = act_dict[anc_obj].indexOf(ancestors[j + 1]); k < act_dict[anc_obj].length; k++) {
                        discriminations[act_dict[anc_obj][k]][i] = 0.1; // donne une petite valeur pour les descendants 
                    }
                    for (let k = 0; k < act_dict[anc_obj].indexOf(ancestors[j + 1]) + 1; k++) {
                        discriminations_no_anc[act_dict[anc_obj][k]][i] = 0.3; // donne une plus grande valeur en cas de réponses négatif
                    }
                }
            }
        }
        for (let j = 0; j < act_dict[obj].length; j++) {
            discriminations[act_dict[obj][j]] = [...discRow];
            discriminations_no_anc[act_dict[obj][j]] = [...discRow_anc];
        }
    }
    return [discriminations, discriminations_no_anc];
};
exports.generateDiscriminationsPrerequisite = generateDiscriminationsPrerequisite;
/**
 * Function to generate difficulties matrices based on the position of an activity in its objective
 * @param obj_list : list of objectives
 * @param act_list : dict of all activities with their corresponding objectives => {objId : [actIds]}
 * @returns the corresponding difficulties
 */
let generateDifficultiesAct = (obj_list, act_dict) => {
    const difficulties = {};
    for (let obj of obj_list) {
        for (let i = 0; i < act_dict[obj].length; i++) {
            difficulties[act_dict[obj][i]] = -(i + 1) / act_dict[obj].length;
        }
    }
    return difficulties;
};
exports.generateDifficultiesAct = generateDifficultiesAct;
/**
 * Extracts an invertible submatrix from the discriminations matrix so that we can use determinental point
 * process algorithm described in (Kulesza et Taskar, 2012, “Determinantal point processes for machine
 * learning”) to sample the first k questions of the test.
 * @param discriminations : discriminations of all items of the test bank
 * @returns a randomly chosen invertible submatrix of the discrimination matrix
 */
let extractRandomInversibleSubmatrix = (discriminations) => {
    const discArray = Array.from(Object.values(discriminations));
    const alreadySeenDisc = [];
    let count = 0;
    const selectedDisc = {};
    var currentDiscIds = [];
    for (let i = 0; i < discArray.length; i++) {
        if (JSON.stringify(alreadySeenDisc).indexOf(JSON.stringify(discArray[i])) < 0) {
            if (count > 0) {
                selectedDisc[currentDiscIds[Math.floor(Math.random() * currentDiscIds.length)]] = alreadySeenDisc[alreadySeenDisc.length - 1];
            }
            alreadySeenDisc.push(discArray[i]);
            count += 1;
        }
        currentDiscIds.push(Object.keys(discriminations)[i]);
    }
    selectedDisc[currentDiscIds[Math.floor(Math.random() * currentDiscIds.length)]] = alreadySeenDisc[alreadySeenDisc.length - 1];
    return selectedDisc;
};
exports.extractRandomInversibleSubmatrix = extractRandomInversibleSubmatrix;
let generateDifficultiesCNED = (params, trainingDifficulties = undefined) => {
    const difficulties = {};
    const idModule = params["graph"]["main_act"];
    const ModuleData = params["graph"]["graph"];
    const ontology = params["graph"]["exercises_ontology"];
    for (let i = 0; i < ontology.length; i++) {
        const actId = ontology[i]["id"];
        if ((trainingDifficulties) && (Object.keys(trainingDifficulties).includes(actId))) {
            let alpha = 1 / (1 + Math.exp(-0.05 * (trainingDifficulties[actId][0] - 150)));
            for (let objId of ModuleData[idModule]["subgroups"][0]) {
                for (let j = 0; j < ModuleData[objId]["subgroups"][0].length; j++) {
                    if (actId == ModuleData[objId]["subgroups"][0][j]) {
                        difficulties[actId] = 2 - 4 * (j / (ModuleData[objId]["subgroups"][0].length));
                        difficulties[actId] *= (1 - alpha);
                        difficulties[actId] += alpha * trainingDifficulties[actId][1];
                    }
                }
            }
        }
        else {
            for (let objId of ModuleData[idModule]["subgroups"][0]) {
                for (let j = 0; j < ModuleData[objId]["subgroups"][0].length; j++) {
                    if (actId == ModuleData[objId]["subgroups"][0][j]) {
                        difficulties[actId] = 2 - 4 * (j / (ModuleData[objId]["subgroups"][0].length));
                    }
                }
            }
        }
    }
    return difficulties;
};
exports.generateDifficultiesCNED = generateDifficultiesCNED;
/**
 * Generates discriminations for items if we don't have enough data for training. Here, we assume that
 * one question involves the objective to which it belongs and all of its prerequisites. The discrimination
 * along the main KC is higher than the discrimination along other dimensions.
 * @param params : config object (same as in the BM)
 * @param graph : representation of the parametric graph created with @evidenceb/parametric-graph lib
 * @returns the discriminations for each item of the test bank under the hypothesis of hierarchical knowledge
 * space
 */
let generateFakeDiscriminationsPrerequisite = (params, graph) => {
    const discriminations = {};
    const idModule = params["graph"]["main_act"];
    const ModuleData = params["graph"]["graph"];
    const ontology = params["graph"]["exercises_ontology"];
    const objectives = ModuleData[idModule]["subgroups"][0];
    for (let j = 0; j < ModuleData[idModule]["subgroups"][0].length; j++) {
        let obj = ModuleData[idModule]["subgroups"][0][j];
        for (let act of ModuleData[obj]["subgroups"][0]) {
            for (let i = 0; i < ontology.length; i++) {
                if (act == ontology[i]["id"]) {
                    let indexesAncestors = [];
                    for (let anc of (0, parametric_graph_1.getAncestors)(graph, act)) {
                        let ind = objectives.indexOf(anc);
                        if (ind >= 0) {
                            indexesAncestors.push(ind);
                        }
                    }
                    let discRow = new Array(ModuleData[idModule]["subgroups"][0].length).fill(0);
                    if (indexesAncestors.length == 1) {
                        discRow[j] = 1;
                    }
                    else {
                        for (let index of indexesAncestors) {
                            discRow[index] = 0.1 / (indexesAncestors.length - 1);
                        }
                        discRow[j] = 0.9;
                    }
                    discriminations[act] = discRow;
                }
            }
        }
    }
    return discriminations;
};
exports.generateFakeDiscriminationsPrerequisite = generateFakeDiscriminationsPrerequisite;
